import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Text, Button, tokens } from '@hotjar/hotsauce';
import { show } from '@hotjar/webapp/features/ProductUpdates';
import type { BeamerPost } from '@hotjar/webapp/features/ProductUpdates/api';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { ArticleLink } from '../ArticleLink';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${tokens.spacer.x1pt5};
`;

const PostsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0;
  list-style: none;
`;

export const NewFeaturesSection = ({ posts }: { posts: BeamerPost[] }): JSX.Element | null => {
  const { click: trackClick } = useTrack();
  const { t } = useTranslation();

  const handleViewAllClick = () => {
    trackClick(`view all`, 'for you - new features section', {});
    show();
  };

  const handlePostClick = (postId: BeamerPost['id']) => {
    trackClick(`post click - ${postId}`, 'for you - new features section', {});
  };

  return (
    <Wrapper>
      <Header>
        <Text as="h2" textType="header5">
          {t('activation:space-overview.for-you.new-features.title')}
        </Text>
        <Button onClick={handleViewAllClick} kind="ghost">
          {t('activation:space-overview.for-you.new-features.view-all')}
        </Button>
      </Header>
      <PostsWrapper>
        {posts.slice(0, 2).map((post, postIndex) => {
          return (
            <ArticleLink
              onClick={() => handlePostClick(post.id)}
              key={post.id}
              href={post.postUrl}
              wrapperLabel={post.title}
              caption={post.date}
              title={post.title}
              imageUrl={post?.images ? post?.images[0] : undefined}
              target="_blank"
              expanded={postIndex === 0}
            />
          );
        })}
      </PostsWrapper>
    </Wrapper>
  );
};
